// Module
var code = `<!-- The question about a file that already exists is not here. A dialog opens in
     the top layer, and a dialog under a hidden element is in that layer without
     being drawn. The panel that holds this drop zone hides its body when the
     operator collapses it, so the panel draws the question outside that body. -->
<!-- Drop Zone -->
<div
        ngf-drop
        ngf-change="\$ctrl.fileDropped(\$files, \$file, \$newFiles, \$duplicateFiles, \$invalidFiles, \$event)"
        ngf-select="\$ctrl.fileDropped(\$files, \$file, \$newFiles, \$duplicateFiles, \$invalidFiles, \$event)"
        ngf-multiple="true"
        ngf-drag-over-class="'asset-upload-drag-over'"
        ngf-hide-on-drop-not-available="true"
        ngf-pattern="!.mov,image/*,video/*"
        ngf-max-size="\$ctrl.maxFileSize"
        class="asset-upload-drop-target"
>
        <div class="asset-upload-title">Click or drop to upload</div>
        <div
                class="asset-upload-files-remaining"
                ng-if="\$ctrl.stats.filesRemaining"
        >
                {{\$ctrl.stats.filesRemaining}} files remaining
        </div>
        <div
                class="asset-upload-bytes-remaining"
                ng-if="\$ctrl.stats.bytesRemaining"
        >
                {{\$ctrl.stats.bytesRemaining | bytes}} remaining
        </div>
</div>
`;
// Exports
export default code;